export enum ContactType {
  OWNER , COMPANY
}
